import type { DataWrapper } from "deprecated/data-wrapper/types";

export function length(data: DataWrapper): number {
    return data.length;
}

export function fields(data: DataWrapper): Array<string> {
    return Object.keys(data.data);
}
